import { FETCH_AGREEMENT_UPLOADS, FETCH_CONFIRMED_OFFERS, FETCH_REPORT_UPLOAD_REQUESTS, FETCH_DEAL_OFFER_STATISTICS,
  FETCH_CURRENCY_EXCHANGE_RATES } from "./actions"
import { PaginatedData } from "../../types/root"
import { AgreementUpload, ConfirmedOffer, ReportsActionProps, ReportsProps, ReportUploadRequest } from "../../types/reports"

export const initialReportsState: ReportsProps = {
  paginatedConfirmedOfferList: new PaginatedData<ConfirmedOffer>(),
  paginatedAgreementUploadList: new PaginatedData<AgreementUpload>(),
  paginatedReportUploadRequestList: new PaginatedData<ReportUploadRequest>(),
  currencyExchangeRates: {},
  dealOfferStatistics: null
}

const reports = (state = initialReportsState, action: ReportsActionProps) => {
  switch (action.type) {
    case FETCH_CONFIRMED_OFFERS: {
      const paginatedConfirmedOfferList =
        (action.payload?.paginatedConfirmedOfferList as PaginatedData<ConfirmedOffer>) ||
        new PaginatedData<ConfirmedOffer>()
      return {
        ...state,
        paginatedConfirmedOfferList
      }
    }
    case FETCH_AGREEMENT_UPLOADS: {
      const paginatedAgreementUploadList =
        (action.payload?.paginatedAgreementUploadList as PaginatedData<AgreementUpload>) ||
        new PaginatedData<AgreementUpload>()
      return {
        ...state,
        paginatedAgreementUploadList
      }
    }
    case FETCH_REPORT_UPLOAD_REQUESTS: {
      const paginatedReportUploadRequestList =
        (action.payload?.paginatedReportUploadRequestList as PaginatedData<ReportUploadRequest>) ||
        new PaginatedData<ReportUploadRequest>()
      return {
        ...state,
        paginatedReportUploadRequestList
      }
    }
    case FETCH_CURRENCY_EXCHANGE_RATES: {
      const currencyExchangeRates = action.payload?.currencyExchangeRates || {}
      return {
        ...state,
        currencyExchangeRates
      }
    }
    case FETCH_DEAL_OFFER_STATISTICS: {
      const dealOfferStatistics = action.payload?.dealOfferStatistics || null
      return {
        ...state,
        dealOfferStatistics
      }
    }
    default: {
      return { ...state }
    }
  }
}

export default reports
